import { Key, PropsWithChildren, useCallback } from "react";

import { InputChoiceContextProvider } from "../../contexts/InputChoiceContext";
import { useInputChoices } from "../../contexts/useInputChoices";
import { InputChoiceInput, InputChoiceInputProps } from "../InputChoiceInput";

import { InputChoiceProps, StyledFlex } from ".";

export function InputChoice<Value extends Key>({
  children,
  value,
  name,
  disabled = false,
  "data-test": dataTest = `input-choice-${value}`,
  ...props
}: PropsWithChildren<InputChoiceProps<Value>>) {
  const { mode, onChange, value: selectedValue } = useInputChoices();
  const active = value === selectedValue;

  const handleOnClick = useCallback(() => {
    if (disabled) {
      return;
    }

    onChange?.(value);
  }, [onChange, value, disabled]);

  return (
    <InputChoiceContextProvider isDisabled={disabled} isSelected={active}>
      <StyledFlex
        data-test={dataTest}
        active={active}
        onClick={handleOnClick}
        mode={mode}
        disabled={disabled}
        flex={1}
        p="s"
        alignItems="center"
        justifyContent="center"
        gap="xxs"
        {...props}
      >
        {children}
        <InputChoiceInput
          name={name}
          value={value as InputChoiceInputProps<Value>["value"]}
          active={active}
          disabled={disabled}
        />
      </StyledFlex>
    </InputChoiceContextProvider>
  );
}
